'use client';

import classes from "./inpus_slider.module.css";

export default function InputSlider({label, ...props}) {
    props.className = `${props.className ? props.className : ""} ${classes["slider-input"]}`;

    return <div className={`${classes["slider-input-container"]}`}>
        {label && <p className="margin-0 color-gray-700 text-sm-medium">{label}</p>}
        <input type="range" {...props} style={{background: `linear-gradient(90deg, #F5BD24 ${props.value}%, #EAECF0 ${props.value}%)`}} />
    </div>
}